import MagicWandIcon from "@redotech/redo-icons/magic-wand-01_filled.svg";
import { Step } from "@redotech/redo-return-core-common/return-flow";
import { verificationFromModel } from "@redotech/redo-return-core-common/return-flow-step-from-model";
import {
  isVerificationStepValid,
  VerificationState,
} from "@redotech/redo-return-core-common/return-flow-step-valid";
import { STEP_TYPE_NAMES } from "@redotech/redo-return-core-common/return-flow/step-type-names";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import { produce } from "immer";
import * as React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

export const VERIFICATION = (
  Details: React.ComponentType<StepTypeDetailsProps<VerificationState>>,
): StepType<VerificationState, Step.Verification> => ({
  Details: (props) => React.createElement(Details, props),
  customTitle: (state) => state.customTitle,
  description: (state) => state.prompt,
  downstream(state) {
    return state.next ? [{ id: state.next }] : [];
  },
  empty: { prompt: "", scope: "return_item" },
  fromModel: (model, id) => verificationFromModel(model, id),
  Icon: MagicWandIcon,
  layout: () => BlockLayout.FULL,
  maxDownstream: () => 1,
  removeConnection(state, targetStepId) {
    return produce(state, (draft) => {
      if (draft.next === targetStepId) {
        draft.next = undefined;
      }
    });
  },
  stepDeleted(state, stepId) {
    return produce(state, (draft) => {
      if (draft.next === stepId) {
        draft.next = undefined;
      }
    });
  },
  title: STEP_TYPE_NAMES[Step.VERIFICATION],
  toModel(state, id) {
    return {
      type: Step.VERIFICATION,
      customTitle: state.customTitle,
      prompt: state.prompt,
      next: state.next ? id(state.next) : null,
      scope: state.scope,
    };
  },
  updateConnection(state, handleIndex, targetStepId) {
    if (handleIndex !== 0) {
      throw new Error(
        `Invalid handle index ${handleIndex} for verification step`,
      );
    }
    return produce(state, (draft) => {
      draft.next = targetStepId;
    });
  },
  valid: (state) => isVerificationStepValid(state).valid,
});
